import { render, staticRenderFns } from "./localData.vue?vue&type=template&id=0f72572e&scoped=true"
import script from "./localData.vue?vue&type=script&lang=js"
export * from "./localData.vue?vue&type=script&lang=js"
import style0 from "./localData.vue?vue&type=style&index=0&id=0f72572e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f72572e",
  null
  
)

export default component.exports